import React, { useState } from 'react'
import { BillingHistory } from './BillingHistory'
import { MessagingCharges } from './MessagingCharges'
import { OrganizationHardware } from './OrganizationHardware'

const Tab = ({ isActive, onClick, children }) => (
  <div
    onClick={onClick}
    className={`${
      isActive ? 't-border-b-[#2e97de] t-border-b-2' : ''
    } t-px-7 t-py-2 t-cursor-pointer t-bg-white`}
  >
    <h1
      className={`${
        isActive ? 't-text-[#2e97de]' : 't-text-black'
      } t-text-base t-font-medium t-text-center roboto-font`}
    >
      {children}
    </h1>
  </div>
)

const SubscriptionTabs = () => {
  const [sec, setSec] = useState(1)

  const handleSection = (val) => {
    setSec(val)
  }

  return (
    <>
      <div className="t-w-full t-flex t-flex-col sm:t-flex-row md:t-justify-start t-justify-center t-border-b-2 t-border-b-gray-100 t-mb-6">
        <Tab isActive={sec === 1} onClick={() => handleSection(1)}>
          Billing History
        </Tab>
        <Tab isActive={sec === 2} onClick={() => handleSection(2)}>
          Messaging Charges
        </Tab>
        <Tab isActive={sec === 3} onClick={() => handleSection(3)}>
          Hardware
        </Tab>
      </div>
      {sec === 1 && <BillingHistory />}
      {sec === 2 && <MessagingCharges />}
      {sec === 3 && <OrganizationHardware />}
    </>
  )
}

export { SubscriptionTabs }
